import { Component } from 'react'
import { observer } from 'mobx-react'
import { urlEncodeName } from 'utils'

import * as h from 'h'

import styles from './styles-tags.scss'

@observer(['AboutStore', 'UiStore'])
export default class Tags extends Component {
  render () {
    const { AboutStore } = this.props

    return h.div(h.ca(styles.container),
      AboutStore.visibleTags.map(t => h.h(Tag, { key: t.name, tag: t }))
    )
  }
}

@observer(['UiStore'])
class Tag extends Component {
  onClick (selected) {
    const { UiStore, tag } = this.props
    UiStore.selectedTag = selected ? null : tag
    UiStore.selectedContact = null
  }

  render () {
    const { UiStore, tag } = this.props
    const { inAboutSingleDetailView, selectedContact, hoveredContact, selectedTag } = UiStore

    const focusSelected = selectedContact && tag.contacts.some(c => c.id === selectedContact.id)
    const focusHovered = hoveredContact && tag.contacts.some(c => c.id === hoveredContact.id)
    const blur = !inAboutSingleDetailView && hoveredContact && !tag.contacts.some(c => c.id === hoveredContact.id)
    const selected = selectedTag && selectedTag.id === tag.id
    const to = selected ? '/about' : `/about/${tag.id}/${urlEncodeName(tag.name)}`

    return h.l({
      to,
      ...h.ca(styles.tag, {
        [styles.selected]: selected,
        [styles.blur]: blur,
        [styles.focus]: focusSelected || focusHovered
      }),
      onMouseOver: () => { UiStore.hoveredTag = tag },
      onMouseOut: () => { UiStore.hoveredTag = null },
      onClick: () => this.onClick(selected),
      name: `filter team members by role`
    },
      h.p(null, tag.name)
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/About/Tags.js